<script>
import * as m from '@app/paraglide/messages.js';
import {
    historyState, undo, redo
} from '@app/store/historyStore.svelte.js';
import {authState} from '@app/store/authStore.svelte.js';
import {
    explorerState
} from '@app/store/explorerStore.svelte.js';
import {
    projectState, resetProjectState
} from '@app/store/projectStore.svelte.js';
import {
    showModal
} from '@app/store/modalStore.svelte.js';
import {
    environment
} from '@app/store/envStore.svelte.js';
import {
    setSpeakerState
} from '@app/store/speakerStore.svelte.js';
import {
    setIssues
} from '@app/store/issueStore.svelte.js';
import {
    resetMarkerStateWithData
} from '@app/store/markerStore.svelte.js';
import {
    setMetadataState
} from '@app/store/metadataStore.svelte.js';
import {
    eventGroupState, setEventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    updateFontState
} from '@app/store/fontStore.svelte.js';
/* Components */
import OfflineSaveIcon from "./menus/items/OfflineSaveIcon.svelte";
import OnlineSaveIcon from "./menus/items/OnlineSaveIcon.svelte";

import _EventGroup from '@cclib/classes/eventGroup.js';
import _Event from '@cclib/classes/event.js';

/* Components */
import AddEvent from './controls/AddEvent.svelte';
import RemoveEvent from './controls/RemoveEvent.svelte';
import AlignLeft from './controls/AlignLeft.svelte';
import AlignCenter from './controls/AlignCenter.svelte';
import AlignRight from './controls/AlignRight.svelte';
import Copy from './controls/Copy.svelte';
import Cut from './controls/Cut.svelte';
import Paste from './controls/Paste.svelte';
import Split from './controls/Split.svelte';
import Merge from './controls/Merge.svelte';
import Expand from './controls/Expand.svelte';
import Compress from './controls/Compress.svelte';
import AutoFormatButton from './controls/AutoFormatButton.svelte';
import Position from './controls/Position.svelte';
import WritingMode from './controls/WritingMode.svelte';
import PositionLineUp from './controls/PositionLineUp.svelte';
import PositionLineDown from './controls/PositionLineDown.svelte';
import ShiftWordBack from './controls/ShiftWordBack.svelte';
import ShiftWordForward from './controls/ShiftWordForward.svelte';
import ShiftLineBack from './controls/ShiftLineBack.svelte';
import ShiftLineForward from './controls/ShiftLineForward.svelte';
import SnapToStart from './controls/SnapToStart.svelte';
import SnapToEnd from './controls/SnapToEnd.svelte';

function undoHistory() {
    undo();
    loadSnapshots();
}

function redoHistory() {
    redo();
    loadSnapshots();    
}

function loadSnapshots() {
    let cachedEvents = eventGroupState[projectState.selected]?.selected;
    eventGroupState[projectState.selected].selected = [];
    historyState.actions[historyState.position-1].snapshots.forEach(snapshot => {
        switch (snapshot.store) {
            case "eventGroupState":
                setEventGroupState(JSON.parse(snapshot.value))
                break;
            case "metadataState":
                // Clear the array first
                setMetadataState(JSON.parse(snapshot.value));
                break;
            case "projectState":
                resetProjectState(JSON.parse(snapshot.value));
                break;
            case "speakerState":
                setSpeakerState(JSON.parse(snapshot.value));
                break;
            case "issueState":
                setIssues(JSON.parse(snapshot.value));
                break;
            case "markerState":
                resetMarkerStateWithData(JSON.parse(snapshot.value));
                break;
            case "fontState":
                updateFontState(snapshot.value);
                break;
            default:
                console.log("----UNKNOWN STORE NAME----");
        }
    });    

    if (historyState.actions[historyState.position-1].eventGroup !== false && historyState.actions[historyState.position-1].eventGroup !== undefined){
        projectState.selected = historyState.actions[historyState.position-1].eventGroup;
        eventGroupState[projectState.selected].selected = [];
    } 
    
    if (eventGroupState[projectState.selected] && eventGroupState[projectState.selected].events[cachedEvents[0]]){
        setTimeout(() =>{
            eventGroupState[projectState.selected].selected = [cachedEvents[0]];
        }, 250)        
    }
}

function openProject(){
    explorerState.context = "load";
    showModal("storageExplorer");
}

</script>

<nav class="navbar navbar-expand bg-light bg-opacity-50 shadow" aria-label={m.toolbar_secondary_aria_label()} style="height: 3vh;">
    <div class="container-fluid">
        <div class="collapse navbar-collapse" id="secondary-toolbar">
            <ul class="nav navbar-nav" aria-label={m.toolbar_secondary_file_operations_aria_label()}>
                {#if !environment.iframe}
                    {#if !environment.online || projectState.useLocalStorage}
                        <li class="nav-item">
                            <a class="nav-link" href="#!/" id="open-project-btn" aria-label={m.toolbar_secondary_open_project_aria_label()} onclick={() => showModal("projectImport")}><i class="bi bi-folder" aria-hidden="true"></i></a>
                        </li>
                    {:else}
                        <li class="nav-item">
                            <a class="nav-link" href="#!/" id="open-project-btn" aria-label={m.toolbar_secondary_open_project_aria_label()} onclick={() => openProject()}><i class="bi bi-folder" aria-hidden="true"></i></a>
                        </li>
                    {/if}
                    {#if !environment.online || projectState.useLocalStorage}
                        <OfflineSaveIcon></OfflineSaveIcon>
                    {:else}
                        <OnlineSaveIcon></OnlineSaveIcon>
                    {/if}                
                    <div class="vr align-self-center" role="separator"></div>
                    <li class="nav-item" title={m.toolbar_secondary_export_file_title()}>
                        <a aria-label={m.toolbar_secondary_export_file_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('fileExport')}><i class="bi bi-upload"></i></a>
                    </li>
                    <li class="nav-item" title={m.toolbar_secondary_import_file_title()}>
                        <a aria-label={m.toolbar_secondary_import_file_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('fileImport')}><i class="bi bi-download"></i></a>
                    </li>     
                    <div class="vr align-self-center" role="separator"></div>      
                    <li class="nav-item" title={m.toolbar_secondary_import_media_title()}>
                        <a aria-label={m.toolbar_secondary_import_media_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('mediaImport')}><i class="bi bi-collection-play"></i></a>
                    </li>     
                    <div class="vr align-self-center" role="separator"></div>     
                    <li class="nav-item" title={m.toolbar_secondary_undo_title()}>
                        <a aria-label={m.toolbar_secondary_undo_aria_label()} class="nav-link {historyState.position <= 1 ? 'disabled' : ''}" href="#!/" onclick={() => undoHistory()}><i class="bi bi-arrow-counterclockwise"></i></a>
                    </li>  
                    <li class="nav-item" title={m.toolbar_secondary_redo_title()}>
                        <a aria-label={m.toolbar_secondary_redo_aria_label()} class="nav-link {historyState.position === historyState.actions.length ? 'disabled' : ''}" href="#!/" onclick={() => redoHistory()}><i class="bi bi-arrow-clockwise"></i></a>
                    </li> 
                    {#if environment.online}
                        <div class="vr align-self-center" role="separator"></div>
                        <li class="nav-item" title={m.toolbar_secondary_automatic_transcription_title()}>
                            <a aria-label={m.toolbar_secondary_automatic_transcription_aria_label()} class="nav-link {!projectState.media.path || projectState.media.storage === "HLS Manifest" || projectState.media.storage === "Vimeo" ? 'disabled' : ''}" href="#!/" onclick={() => showModal('automaticTranscription')}><i class="bi bi-mic"></i><sub><i class="bi bi-blockquote-left"></i></sub></a>
                        </li>  
                        {#if authState.plan === 'pro' || authState.plan === 'enterprise'}
                        <li class="nav-item" title={m.toolbar_secondary_automatic_translation_title()}>
                            <a aria-label={m.toolbar_secondary_automatic_translation_aria_label()} class="nav-link {!eventGroupState[projectState.selected] ? 'disabled' : ''}" href="#!/" onclick={() => showModal('automaticTranslation')}><i class="bi bi-translate"></i></a>
                        </li>  
                        {/if}
                    {/if}
                    <div class="vr align-self-center" role="separator"></div>
                    <li class="nav-item" title={m.toolbar_secondary_settings_title()}>
                        <a aria-label={m.toolbar_secondary_options_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('options')}><i class="bi bi-gear"></i></a>
                    </li> 
                    <li class="nav-item" title={m.toolbar_secondary_keyboard_shortcuts_title()}>
                        <a aria-label={m.toolbar_secondary_shortcut_keys_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('shortcutKeys')}><i class="bi bi-keyboard"></i></a>
                    </li>
                {:else}
                    <li class="nav-item" title={m.toolbar_secondary_undo_title()}>
                        <a aria-label={m.toolbar_secondary_undo_aria_label()} class="nav-link {historyState.position <= 1 ? 'disabled' : ''}" href="#!/" onclick={() => undoHistory()}><i class="bi bi-arrow-counterclockwise"></i></a>
                    </li>  
                    <li class="nav-item" title={m.toolbar_secondary_redo_title()}>
                        <a aria-label={m.toolbar_secondary_redo_aria_label()} class="nav-link {historyState.position === historyState.actions.length ? 'disabled' : ''}" href="#!/" onclick={() => redoHistory()}><i class="bi bi-arrow-clockwise"></i></a>
                    </li> 
                    <li class="nav-item" title={m.toolbar_secondary_keyboard_shortcuts_title()}>
                        <a aria-label={m.toolbar_secondary_shortcut_keys_aria_label()} class="nav-link" href="#!/" onclick={() => showModal('shortcutKeys')}><i class="bi bi-keyboard"></i></a>
                    </li>
                {/if}
                
            </ul>
            <ul class="nav navbar-nav ms-auto" aria-label={m.toolbar_secondary_caption_editing_aria_label()}>
                <AddEvent></AddEvent>
                <RemoveEvent></RemoveEvent>
                <div class="vr align-self-center" role="separator"></div>
                <AlignLeft></AlignLeft>
                <AlignCenter></AlignCenter>
                <AlignRight></AlignRight>
                <WritingMode></WritingMode>
                <div class="vr align-self-center" role="separator"></div>
                <Position></Position>                
                <PositionLineUp></PositionLineUp>
                <PositionLineDown></PositionLineDown>
                <div class="vr align-self-center" role="separator"></div>
                <Copy></Copy>
                <Cut></Cut>
                <Paste></Paste>
                <div class="vr align-self-center" role="separator"></div>
                <ShiftWordBack></ShiftWordBack>
                <ShiftWordForward></ShiftWordForward>
                <ShiftLineBack></ShiftLineBack>
                <ShiftLineForward></ShiftLineForward>
                <div class="vr align-self-center" role="separator"></div>
                <Split></Split>
                <Merge></Merge>
                <div class="vr align-self-center" role="separator"></div>
                <Expand></Expand>
                <Compress></Compress>
                <AutoFormatButton></AutoFormatButton>
                <div class="vr align-self-center" role="separator"></div>
                <SnapToStart></SnapToStart>
                <SnapToEnd></SnapToEnd>                                
            </ul>
        </div>
    </div>
</nav>
<style lang="css">
    ul {
        align-items: baseline;
    }
    
    .nav-link {
        font-size: 0.75vw;
    }
</style>